module.exports = __webpack_public_path__ + "img/3.652985aa.jpg";